import { render, staticRenderFns } from "./LinkEntityRole.vue?vue&type=template&id=fed6509e&scoped=true"
import script from "./LinkEntityRole.vue?vue&type=script&lang=js"
export * from "./LinkEntityRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed6509e",
  null
  
)

export default component.exports